import React from 'react'
import PropTypes from 'prop-types'
import { GlobalContext, UserContext } from 'components/context'
import { Link } from 'react-router-dom'
import { featureExcluded } from 'components/features'

const lastPin = (keys) => {
  if (!keys) return

  const pins = keys.filter(k => k.type === 'pin')
  if (pins.length < 1) return
  if (pins.length === 1) return pins[0]

  // There might be more than one PIN, so
  // we find the one that was activated last
  return pins.reduce((a, b) => a.valid_from > b.valid_from ? a : b)
}

// PinInfo for operators without nfc enabled
const PinInfo = ({ rfid }) => {
  const { t } = React.useContext(GlobalContext)
  const { membership } = React.useContext(UserContext)
  const excluded = featureExcluded('nfc', 'location', membership.location.name)

  if (!membership) return null

  if (rfid) return null

  const pin = lastPin(membership.keys)
  const pinActive = pin && pin.status === 'active'

  return (
    <div className={'index-info full-width'}>
      { pin &&
        <div>
          <h2>{ t('pages.pin.title') }</h2>
          <div className={ pinActive ? 'code' : 'code-inactive'}>{pin?.code}</div>
          <div className={ pinActive ? 'invisible' : 'expiry-label'}>Expired</div>
        </div>
      }
      <div className={'access-info'}>
        <h3>{ t('pages.pin.list.title') }</h3>
        <ol>
          <li>{ t('pages.pin.list.use_code') } { t('pages.pin.list.valid_period') }</li>
          <li>{ t('pages.pin.list.pick_up_access_chip') }</li>
          <li>
            <Link to={'/membership/activate-chip'}>
              { t('pages.pin.list.activate_access_chip') }
            </Link>
          </li>
        </ol>
        { excluded &&
          <div className='excluded'>
            <p className='warn'>{t('pages.membership.access.nfc.temporarily_unavailable.header')}</p>
            <p>{t('pages.membership.access.nfc.temporarily_unavailable.text', { name: membership.location.name })}</p>
          </div>
        }
      </div>
    </div>
  )
}

PinInfo.propTypes = {
  rfid: PropTypes.object,
}

export default PinInfo
